// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectorItem__container-ca4b80 {
  width: 100%;
  cursor: pointer;
  min-height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: 56px;
  padding-inline-end: 16px;
  color: var(--base-110);
}

.SelectorItem__container-ca4b80:hover,
.SelectorItem__container-ca4b80:focus-visible {
  background-color: var(--base-17);
}

.SelectorItem__container-ca4b80:active {
  background-color: var(--base-20);
}

.SelectorItem__container-ca4b80.SelectorItem__is-selected-ab8bf0 {
  padding-inline-start: 16px;
}

.SelectorItem__check-icon-e8c9b5 {
  margin-inline-end: 16px;
  fill: var(--base-110);
}

.SelectorItem__is-selected-ab8bf0 .SelectorItem__title-selected-c908c1 {
  font: var(--font-body-2);
}

.SelectorItem__title-ca4b69 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Selector/SelectorItem/SelectorItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,sBAAA;AAAF;;AAGA;;EAEE,gCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,uBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,gBAAA;AAAF","sourcesContent":[".container {\n  width: 100%;\n  cursor: pointer;\n  min-height: 40px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-inline-start: 56px;\n  padding-inline-end: 16px;\n  color: var(--base-110);\n}\n\n.container:hover,\n.container:focus-visible {\n  background-color: var(--base-17);\n}\n\n.container:active {\n  background-color: var(--base-20);\n}\n\n.container.is-selected {\n  padding-inline-start: 16px;\n}\n\n.check-icon {\n  margin-inline-end: 16px;\n  fill: var(--base-110);\n}\n\n.is-selected .title-selected {\n  font: var(--font-body-2);\n}\n\n.title {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  flex: 1;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SelectorItem__container-ca4b80`,
	"is-selected": `SelectorItem__is-selected-ab8bf0`,
	"isSelected": `SelectorItem__is-selected-ab8bf0`,
	"check-icon": `SelectorItem__check-icon-e8c9b5`,
	"checkIcon": `SelectorItem__check-icon-e8c9b5`,
	"title-selected": `SelectorItem__title-selected-c908c1`,
	"titleSelected": `SelectorItem__title-selected-c908c1`,
	"title": `SelectorItem__title-ca4b69`
};
module.exports = ___CSS_LOADER_EXPORT___;
